import { render, staticRenderFns } from "./pppk.vue?vue&type=template&id=4642515c"
import script from "./pppk.vue?vue&type=script&lang=js"
export * from "./pppk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports